"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgressBar = void 0;

var _react = _interopRequireDefault(require("react"));

var _Theme = require("../../Theme");

var _Box = require("../Box");

var _excluded = ["percentComplete", "highlight", "showBackground", "transition"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/** ProgressBar */
var ProgressBar = function ProgressBar(_ref) {
  var percentComplete = _ref.percentComplete,
      _ref$highlight = _ref.highlight,
      highlight = _ref$highlight === void 0 ? "brand" : _ref$highlight,
      _ref$showBackground = _ref.showBackground,
      showBackground = _ref$showBackground === void 0 ? true : _ref$showBackground,
      _ref$transition = _ref.transition,
      transition = _ref$transition === void 0 ? "transform 1s ease" : _ref$transition,
      rest = _objectWithoutProperties(_ref, _excluded);

  var bgColor = (0, _Theme.useThemeConfig)({
    v2: "black10",
    v3: "black30"
  });
  return /*#__PURE__*/_react.default.createElement(_Box.Box, _extends({
    tabIndex: 0,
    role: "progressbar",
    "aria-valuenow": percentComplete,
    "aria-valuemin": 0,
    "aria-valuemax": 100,
    height: "2px",
    position: "relative",
    overflow: "hidden",
    mt: 0.5,
    mb: 1,
    bg: showBackground ? bgColor : "transparent"
  }, rest), /*#__PURE__*/_react.default.createElement(_Box.Box, {
    bg: highlight,
    width: "100%",
    height: "100%",
    style: {
      transition: transition,
      transform: "translateX(-".concat(100 - percentComplete, "%)"),
      backfaceVisibility: "hidden"
    }
  }));
};

exports.ProgressBar = ProgressBar;
ProgressBar.displayName = "ProgressBar";
//# sourceMappingURL=ProgressBar.js.map